
import axios from "axios";
import moment, { Moment } from "moment";
import { push } from 'react-router-redux';
import { AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { State } from '~/Reducers';
import { scrollToBuiding } from '../Components/ViewSupply/ViewSupply';
import { distributeResourcesError } from "../web2ClientAPI/notifications";
import { fetchClan, fetchMembers } from "./ActionClanProfile";
import { startFetching, stopFetching } from "./ActionProcessing";
import { SelectBuilding } from './ActionSupply';
import { syncAccountInfo } from './ActionAccount'

export const TRANSACTIONS_STATUSES = {
  COMPLETED: 'completed',
  PENDING: 'pending',
  FAILED: 'failed'
};

export const TRANSACTIONS_STATUSES_MAP = {
  completed: 'completed',
  pending: 'pending',
  failed: 'failed',
  committed: 'completed',
  rolled_back: 'failed',
  in_progress: 'pending'
};

export const SELECT_DISTRIBUTION_CURRENCY = 'SELECT_DISTRIBUTION_CURRENCY';
export const selectDistributionCurrency = (type: CurrencyType): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: SELECT_DISTRIBUTION_CURRENCY,
    payload: {
      type
    }
  })
}

export const SET_DISTRIBUTION_SUM = 'SET_DISTRIBUTION_SUM_DIRECTION';
export const setDistributionSum = (sum: number): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: SET_DISTRIBUTION_SUM,
    payload: {
      sum
    }
  });
};

export const TOGGLE_DISTRIBUTION_MEMBERS = 'TOGGLE_DISTRIBUTION_MEMBERS_DIRECTION';
export const toggleDistributionMembers = (members: Array<Member>, toggleAll: boolean): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: TOGGLE_DISTRIBUTION_MEMBERS,
    payload: {
      members,
      toggleAll
    }
  });
};

export const SET_TRANSACTION_SUM_UPDATING = 'SET_TRANSACTION_SUM_UPDATING';
export const setTransactionSumUpdating = (): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: SET_TRANSACTION_SUM_UPDATING
  });
};


export const GET_TOTAL_TRANSACTIONS_SUM = 'GET_TOTAL_TRANSACTIONS_SUM';
export const getTotalTransactionsSum = (): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  const state = getState();

  const startDate = state.ReducerTreasury.filterStartDate;

  const endDate = state.ReducerTreasury.filterEndDate;

  const directionIndex = state.ReducerTreasury.selectedTab;

  if (state.urls.clanTreasuryOperationsTotals) {
    let url = state.urls.clanTreasuryOperationsTotals;

    const connector = url.indexOf('?') !== -1 ? '&' : '?';

    url = `${url}${connector}type=${getTransactiontype(directionIndex)}`;

    if (startDate && endDate) {
      const start = startDate.utc().format();
      const end = endDate.utc().format();
      url = `${url}&since=${start}&until=${end}`;
    }

    axios.get(url).then(response => {
      if (response.status === 200 && response.data && response.data.length) {
        dispatch({
          type: GET_TOTAL_TRANSACTIONS_SUM,
          payload: {
            totalTransactionsSum: response.data.filter((item: any) => item.amount > 0).map((item: any) => {
              return {
                type: item.type,
                amount: item.amount
              };
            })
          }
        });
      }
    });
  }
};


export const GET_TOTAL_BALANCE = 'GET_TOTAL_BALANCE';
export const getTotalBalance = (): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {

  const state = getState();

  const clanId = state.currentAccount.clanId;

  const clan = state.clans.items[state.currentAccount.clanId];
  const personalResource = (clan && clan.personalResource) ? clan.personalResource : 0;

  const personalResourceBalanceOItem = { type: 'oil', amount: personalResource, canDistribute: false };

  if (state.urls.clanTreasuryBalance) {
    let url = state.urls.clanTreasuryBalance;
    axios.get(url).then(response => {

      const totalBalanceList = response.data.map(item => {
        return {
          type: item.type,
          amount: item.amount,
          canDistribute: item.type !== 'oil'
        };
      });
      totalBalanceList.push(personalResourceBalanceOItem);


      dispatch({
        type: GET_TOTAL_BALANCE,
        payload: {
          totalBalanceList: totalBalanceList
        }
      });
    }).catch(err => {
      dispatch({
        type: GET_TOTAL_BALANCE,
        payload: {
          totalBalanceList: []
        }
      });
    });
  } else {
    console.error('no clanTreasuryBalance url');
  }
};

export const SET_FILTER_DATES = 'SET_FILTER_DATES';
export const setFilterDates = (start: Moment, end: Moment): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  if (start) {
    start.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
  }

  if (end) {
    end.set({ hour: 23, minute: 59, second: 59, millisecond: 0 });
  }

  dispatch({
    type: SET_FILTER_DATES,
    payload: {
      start,
      end
    }
  });
  dispatch(filterTransactions());
};


export const SHOW_DISTRIBUTION_DIALOG = 'SHOW_DISTRIBUTION_DIALOG';
export const showDistributionDialog = (): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: SHOW_DISTRIBUTION_DIALOG
  });
};

export const HIDE_DISTRIBUTION_DIALOG = 'HIDE_DISTRIBUTION_DIALOG';
export const hideDistributionDialog = (): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: HIDE_DISTRIBUTION_DIALOG
  });
};


export const FILTER_TRANSACTIONS = 'FILTER_TRANSACTIONS'
export const filterTransactions = (): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {

  const state = getState();
  const startDate = state.ReducerTreasury.filterStartDate;
  const endDate = state.ReducerTreasury.filterEndDate;

  if ((startDate && endDate) || (!startDate && !endDate)) {
    dispatch(getTransactions(false));
  }
};

export const SET_SELECTED_TAB = 'SET_SELECTED_TAB_TREASURY';
export const setSelectedTab = (index: number, userRouter = false): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  const state = getState()

  if (userRouter) {
    switch (index) {
      case 0: {
        dispatch(push(`${state.urls.root}treasury/expenses`))
        break
      }
      case 1: {
        dispatch(push(`${state.urls.root}treasury/income`))
        break
      }
      case 2: {
        dispatch(push(`${state.urls.root}treasury/distribution`))
        break
      }
      case 3: {
        dispatch(push(`${state.urls.root}treasury/regularRewards`))
        break
      }
      default: {
        break
      }
    }
  } else {
    dispatch({
      type: SET_SELECTED_TAB,
      payload: {
        index,
      },
    })
  }

  if (index !== 2) {
    dispatch(getTransactions(false))
  }
};

export const INIT = 'INIT_TREASURY'
export const init = (): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {

  const state = getState();
  const clanId = state.currentAccount.clanId;

  dispatch(fetchMembers(clanId, false, 'cvc_or_brawl'));
  dispatch(fetchClan(clanId, false)).then(r => {
    dispatch(getTreasuryConfig())
    dispatch(getTransactions(false));
  });


};

const sortByDateString = (left, right) => {
  return -moment.utc(left.date).diff(moment.utc(right.date));
}

export const SET_IS_TRANSACTION_LIST_UPDATING = 'SET_IS_TRANSACTION_LIST_UPDATING'
export const setIsTransactionsUpdating = (isUpdating: boolean): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: SET_IS_TRANSACTION_LIST_UPDATING,
    payload: {
      isUpdating
    }
  });
};

const getTransactiontype = (index: number): string => {
  switch (index) {
    case 0:
      {
        return 'credit';
      }
    case 1:
      {
        return 'debit';
      }
    default:
      {
        return 'credit';
      }

  }
};

export const GET_TRANSACTIONS = 'GET_TRANSACTIONS';
export const getTransactions = (isFromAppend: boolean): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  const state = getState()

  const selectedDirection = state.ReducerTreasury.selectedTab

  const startDate = state.ReducerTreasury.filterStartDate

  const endDate = state.ReducerTreasury.filterEndDate

  const clanId = state.currentAccount.clanId

  let directionIndex = state.ReducerTreasury.selectedTab

  const isAppending = state.ReducerTreasury.isAppending

  const queryOffset = state.ReducerTreasury.transactionsOffset

  const lastOffet = state.ReducerTreasury.lastOffet

  if (!clanId) {
    return
  }

  if (lastOffet === queryOffset && isAppending) {
    return
  }

  if (!isFromAppend) {
    dispatch(getTotalBalance())
  }

  if (state.urls.clanTreasuryOperations) {

    if (!isAppending) {
      dispatch(setIsTransactionsUpdating(true))
    }

    let url = state.urls.clanTreasuryOperations

    const connector = (url.indexOf('?') !== -1) ? '&' : '?'

    url = `${url}${connector}type=${getTransactiontype(directionIndex)}`

    if (startDate && endDate) {
      const start = startDate.utc().format()
      const end = endDate.utc().format()
      url = `${url}&since=${start}&until=${end}`
    }

    if (isAppending) {
      url = `${url}&offset=${queryOffset}`
    }

    axios.get(url).then((response) => {

      const data = response.data

      let transactionsListRaw = {}

      if (data && data.length) {

        let innerTransactions = {}

        data.forEach(transaction => {
          if (!!transaction.data.parentId) {
            if (innerTransactions[transaction.data.parentId]) {
              innerTransactions[transaction.data.parentId].push(transaction)
            } else {
              innerTransactions[transaction.data.parentId] = [transaction]
            }
          }
        })

        data.forEach((item, index) => {
          const dateKey = (item && item.date) ? moment(item.date).format('DD_MM_YYYY') : null
          if (dateKey) {
            if (!item.data.parentId) {
              let mergedItem = {
                ...item
              }
              if (innerTransactions[item.id]) {
                mergedItem.childTransactions = innerTransactions[item.id]
              }
              if (!transactionsListRaw[dateKey]) {
                transactionsListRaw[dateKey] = [mergedItem]
              } else {
                transactionsListRaw[dateKey].push(mergedItem)
              }
            }
          }
        })
      }

      const transactionRaw = []

      for (const key in transactionsListRaw) {
        if (transactionsListRaw.hasOwnProperty(key)) {
          const oneDayTransactions = transactionsListRaw[key]
          const oneDaySorted = oneDayTransactions.sort(sortByDateString)
          transactionRaw.push({
            date: moment.utc(key, 'DD_MM_YYYY').toISOString(),
            transactions: oneDaySorted,
          })
        }
      }

      const transactionsSorted = transactionRaw.sort(sortByDateString)

      dispatch({
        type: GET_TRANSACTIONS,
        payload: {
          transactions: transactionsSorted,
          lastOffet: queryOffset,
        },
      })
      dispatch(setIsTransactionsUpdating(false))
      dispatch(getTotalTransactionsSum())
      dispatch(listenTransactionsStatusUpdates())
    }).catch((err) => {
      console.error(err)
      dispatch(setIsTransactionsUpdating(false))
    })

  } else {
    console.error('no url to get transactions')
  }
};

export const DISTRIBUTE_RESOURCES = 'DISTRIBUTE_RESOURCES';
export const distributeResources = (): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch(startFetching())
  const state = getState()
  const clanId = state.currentAccount.clanId
  let url = state.urls.clanTreasury.replace('{clan_id}', clanId)

  axios.put(url, {
    currency: state.ReducerTreasury.selectedDistributionCurrency,
    delta: state.ReducerTreasury.distributionSum,
    initiator_id: state.currentAccount.id,
    receivers: state.ReducerTreasury.distributionList,
  }).then((responce) => {
    dispatch(stopFetching())
    dispatch(setSelectedTab(0, true))

  }).catch((err) => {
    dispatch(stopFetching())
    distributeResourcesError()
  })

  dispatch(hideDistributionDialog())
};

export const SHOW_DISTRIBUTION_RESULT_DIALOG = 'SHOW_DISTRIBUTION_RESULT_DIALOG';
export const showDistributionResultDialog = (transaction: Transaction): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: SHOW_DISTRIBUTION_RESULT_DIALOG,
    payload: {
      transaction: transaction
    }
  });
};

export const HIDE_DISTRIBUTION_RESULT_DIALOG = 'HIDE_DISTRIBUTION_RESULT_DIALOG';
export const hideDistributionResultDialog = (): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: HIDE_DISTRIBUTION_RESULT_DIALOG
  });
};

export const LISTEN_TRANSACTIONS_STATUS_UPDATES = 'LISTEN_TRANSACTIONS_STATUS_UPDATES';
export const listenTransactionsStatusUpdates = (): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  const state = getState()
  const transactions = state.ReducerTreasury.transactions

  const listeningIds = []

  transactions.forEach((dayTransactions) => {
    if (dayTransactions && dayTransactions.transactions) {
      dayTransactions.transactions.forEach((singleTransaction) => {
        if (singleTransaction && singleTransaction.status === TRANSACTIONS_STATUSES.PENDING) {
          if (singleTransaction.data && singleTransaction.data.gameTransactionId) {
            listeningIds.push(singleTransaction.data.gameTransactionId)
          }
        }
        if (singleTransaction.childTransactions && singleTransaction.childTransactions.length) {
          singleTransaction.childTransactions.forEach(childTransaction => {
            if (childTransaction && childTransaction.status === TRANSACTIONS_STATUSES.PENDING) {
              if (childTransaction.data && childTransaction.data.gameTransactionId) {
                listeningIds.push(childTransaction.data.gameTransactionId)
              }
            }
          })
        }
      })
    }
  })

  if (listeningIds.length > 0) {
    const url = `${state.urls.clanTransactions}${(state.urls.clanTransactions.indexOf('?') !== -1) ? '&' : '?'}ids=${listeningIds.join(',')}`

    axios.get(url).then((response) => {
      if (response.status === 200) {
        dispatch({
          type: LISTEN_TRANSACTIONS_STATUS_UPDATES,
          payload: {
            data: response.data,
          },
        })

        setTimeout(() => {
          dispatch(listenTransactionsStatusUpdates())
        }, 1000)
      }
    }).catch((error) => {
      console.error(error)
    })

  } else {
    dispatch(updateTreasuryBoxesCooldown())
    dispatch(syncAccountInfo())
  }
};

export const APPEND_TRANSACTIONS = 'APPEND_TRANSACTIONS';
export const appendTransactions = (): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {

  dispatch({
    type: APPEND_TRANSACTIONS,
    payload: {
      isAppending: true
    }
  });
  dispatch(getTransactions(true));
};

export const REPEATE_FAILED_DISTRIBUTION = 'REPEATE_FAILED_DISTRIBUTION';
export const repeatFailedDistribution = (): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {

  const state = getState();
  const transaction = { ...state.ReducerTreasury.detailViewTransaction };
  const firstReceiver = (transaction.data.receivers && transaction.data.receivers[0]) ? transaction.data.receivers[0] : null;
  if (firstReceiver) {
    const currencyType = firstReceiver.delta.type;
    const distributionSumm = firstReceiver.delta.amount;
    const members = transaction.data.failedReceivers;

    dispatch(hideDistributionResultDialog());
    dispatch(selectDistributionCurrency(currencyType));
    dispatch(setDistributionSum(distributionSumm));
    dispatch(toggleDistributionMembers(members, false));
    dispatch(showDistributionDialog());
  }

};

export const SET_DISTRIBUTION_FILTER = 'SET_DISTRIBUTION_FILTER';
export const setDistributionFilter = (value: string): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: SET_DISTRIBUTION_FILTER,
    payload: {
      value
    }
  });
};

export const TOGGLE_IS_DISTRIBUTION_FILTER_VISIBLE = 'TOGGLE_IS_DISTRIBUTION_FILTER_VISIBLE';
export const toggleIsDistributionFilterVisible = (): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: TOGGLE_IS_DISTRIBUTION_FILTER_VISIBLE
  });
};

export const SET_SORT_FIELD = 'SET_SORT_FIELD';
export const setSortField = (field: string): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: SET_SORT_FIELD,
    payload: {
      sortField: field
    }
  });
};


export const navigateToTreasuryBuilding = () => (dispatch: Dispatch, getState: GetState) => {
  const state = getState()
  dispatch(push(`${state.urls.root}profile`))
  setTimeout(() => {
    scrollToBuiding('treasury')
    dispatch(SelectBuilding('treasury', state.currentAccount.clanId, false))
  }, 200);
}

export const GET_TREASURY_CONFIG = 'GET_TREASURY_CONFIG'
export const getTreasuryConfig = () => (dispatch: Dispatch, getState: GetState) => {
  const state = getState()
  dispatch({
    type: GET_TREASURY_CONFIG,
    payload: {
      config: state.settings.treasury
    }
  })
  dispatch(updateTreasuryBoxesCooldown())
}

export const BUY_TREASURY_BOX = 'BUY_TREASURY_BOX'
export const buyTreasuryBox = (offerId: string) => (dispatch: Dispatch, getState: GetState) => {
    const state = getState()
    dispatch(startFetching())

    if (state.urls.clanTreasuryBuyReward) {
        axios.put(state.urls.clanTreasuryBuyReward, {
            offer: offerId,
        }).then((response) => {
            dispatch(stopFetching())
            dispatch(getTransactions(false))
            dispatch(updateTreasuryBoxesCooldown())
            dispatch(syncAccountInfo())
        }).catch(error => {
            dispatch(stopFetching())
            console.error(error)
        })
    }
}

export const UPDATE_TREASURY_BOXES_COOLDOWN = 'UPDATE_TREASURY_BOXES_COOLDOWN'
export const updateTreasuryBoxesCooldown = () => (dispatch: Dispatch, getState: GetState) => {
  const state = getState()

  if (state.urls.clanTreasuryRewards) {
    axios.get(state.urls.clanTreasuryRewards).then((response) => {
      dispatch({
        type: UPDATE_TREASURY_BOXES_COOLDOWN,
        payload: {
          data: response.data
        }
      })
      dispatch(stopFetching())
    }).catch(error => {
      dispatch(stopFetching())
      console.error(error)
    })
  }
}

export const REPEAT_TREASURY_BOX_TRANSACTION = 'REPEAT_TREASURY_BOX_TRANSACTION'
export const repeatTreasuryBoxTransaction = (id) => (dispatch: Dispatch, getState: GetState) => {
  const state = getState()

  if (state.urls.clanTreasuryBuyRewardRepeat) {
    axios.post(state.urls.clanTreasuryBuyRewardRepeat, {
      treasury_transaction_id: id
    }).then((response) => {
      dispatch(getTransactions(false))
    }).catch(error => {
      console.error(error)
    })
  }
}

export const OPEN_REGULAR_REWARD_CONFIRM_DIALOG = 'OPEN_REGULAR_REWARD_CONFIRM_DIALOG'
export const openRegularRewardConfirmDialog = (reward) => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: OPEN_REGULAR_REWARD_CONFIRM_DIALOG,
    payload: {
      reward: reward
    }
  })
}

export const CLOSE_REGULAR_REWARD_CONFIRM_DIALOG = 'CLOSE_REGULAR_REWARD_CONFIRM_DIALOG'
export const closeRegularRewardConfirmDialog = () => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: CLOSE_REGULAR_REWARD_CONFIRM_DIALOG,
  })
}